import { Component, ViewChild } from '@angular/core';
import { Store } from '@ngrx/store';
import * as fromRoot from 'src/store';
import * as fromWorkspace from 'src/store/workspace';
import { Observable, Subscription } from 'rxjs';
import { Message } from 'src/store/workspace/workspace.model';
import { trigger, transition, style, animate } from '@angular/animations';

@Component({
  selector: 'app-alert',
  templateUrl: './alert.component.html',
  styleUrls: ['./alert.component.scss'],
  animations: [trigger(
    'enterAnimation', [
      transition(':enter', [
        style({transform: 'translateX(100%)', opacity: 0}),
        animate('500ms', style({transform: 'translateX(0)', opacity: 1}))
      ]),
      transition(':leave', [
        style({transform: 'translateX(0)', opacity: 1}),
        animate('500ms', style({transform: 'translateX(100%)', opacity: 0}))
      ])
    ]
  )]
})
export class AlertComponent {
  @ViewChild('alert', {static: false}) alert: HTMLDivElement;
  message$: Observable<Message>;
  messageSubs: Subscription;
  getClass = getClass;

  constructor(private store: Store<fromRoot.AppState>) {
    this.message$ = this.store.select(state => state.workspace.notification);
    this.message$.subscribe(() => {
      setTimeout(() => {
        this.store.dispatch(new fromWorkspace.RemoveMessage());
      }, 10000);
    });
  }
}

export function getClass(message: Message) {
  const className = `alert-${message.type}`;
  const ret = {};
  ret[className] = true;
  return ret;
};